import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Spinner from 'component/utils/Spinner'
import MaintenancePage from 'component/utils/MaintenancePage'
import API_URL from 'constants/api'
import ApiRequest from 'utils/ApiRequest'

class App extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    visibleSpinner: PropTypes.bool,
    spinnerRequests: PropTypes.array,
    isReactive: PropTypes.bool,
    reactiveCallback: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    dispatch: PropTypes.func,
    location: PropTypes.object,
  }

  state = {
    maintenanceChecked: false,
    maintenanceMessage: null,
  }

  componentDidMount() {
    this.checkMaintenance()
  }

  componentDidUpdate(prevProps) {
    // Re-check when the user logs out (or session expires)
    if (prevProps.isAuthenticated && !this.props.isAuthenticated) {
      this.checkMaintenance()
    }
  }

  /**
   * Unauthenticated users on any route: checks if the system is under
   * maintenance (public endpoint). If so, every login is blocked and the
   * maintenance page is shown. Authenticated users are not affected.
   */
  checkMaintenance() {
    const { isAuthenticated, dispatch } = this.props

    if (isAuthenticated) {
      this.setState({ maintenanceChecked: true, maintenanceMessage: null })

      return
    }

    this.setState({ maintenanceChecked: false })

    new ApiRequest(null, dispatch)
      .get(API_URL.MAINTENANCE_CONSULT)
      .then((response) => {
        const maintenanceMessage = (response && response.message) || null

        this.setState({ maintenanceChecked: true, maintenanceMessage })

        // Maintenance active: send the user to /login so the URL reflects the
        // blocked state instead of staying on the (now hidden) requested route.
        const { location } = this.props

        if (maintenanceMessage && location && location.pathname !== '/login') {
          dispatch(push('/login'))
        }
      })
      .catch(() =>
        // 404 (no active block) or any failure: do not block the login
        this.setState({ maintenanceChecked: true, maintenanceMessage: null })
      )
  }

  render() {
    const { visibleSpinner, spinnerRequests, isReactive = false, reactiveCallback, isAuthenticated } = this.props
    const { maintenanceChecked, maintenanceMessage } = this.state

    if (!isAuthenticated) {
      // Avoids flashing the login while the maintenance check is pending
      if (!maintenanceChecked) {
        return <section />
      }

      if (maintenanceMessage) {
        return (
          <section>
            <MaintenancePage message={maintenanceMessage} />
          </section>
        )
      }
    }

    return (
      <section>
        {visibleSpinner && <Spinner isReactive={isReactive} reactiveCallback={reactiveCallback} visible={visibleSpinner} requests={spinnerRequests} />}
        {React.cloneElement(this.props.children, this.props)}
      </section>
    )
  }
}

const mapStateToProps = ({ spinnerReducer, auth }) => ({
  isReactive: spinnerReducer.isReactive,
  reactiveCallback: spinnerReducer.reactiveCallback,
  visibleSpinner: spinnerReducer.visible,
  spinnerRequests: spinnerReducer.requests,
  isAuthenticated: auth.isAuthenticated,
})

export default connect(mapStateToProps)(App)
